<script>
import {mapGetters} from "vuex";
import {DISPLAY_MODE_DESKTOP, DISPLAY_MODE_TABLET, FLYER_ORIENTATION_VERTICAL} from "@/store/modules/screen";
import GridRenderer from "@/components/grid-renderer/GridRenderer.vue";
import FlyerBlock from "@/components/block/FlyerBlock.vue";
import searchGridRenderMixin from "@/mixins/searchGridRenderMixin";

export default {
	name: "FlyerPageRenderer",
	components: {FlyerBlock, GridRenderer},
	mixins: [searchGridRenderMixin],
	props:{
		page: {
			type: Object,
			required: true
		},
		rowHeight: {
			type: Number,
			default: null
		},
		colWidth: {
			type: Number,
			default: null
		},
		forceColCount: {
			type: Number,
			default: null
		},
		forceRowCount:{
			type: Number,
			default: null
		}
	},
	computed:{
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		blocks(){
			return this.page.blocks;
			/*const blocks = [...this.page.blocks];
			return blocks.sort((a, b) => {
				const a1 = a.colSpan * a.rowSpan;
				const a2 = b.colSpan * b.rowSpan;
				return a1 - a2;
			});*/

			//return [this.page.blocks[45], this.page.blocks[46],this.page.blocks[47],this.page.blocks[48]];
		},
		grid(){
			const mode = this.displayMode === DISPLAY_MODE_DESKTOP && this.flyerOrientation === FLYER_ORIENTATION_VERTICAL ? DISPLAY_MODE_TABLET: this.displayMode;
			return this.page?.grids[mode];
		},
		colCount() {
			return this.colWidth ? Math.ceil((this.page.unitWidth / this.colWidth) * (this.grid?.colCount || 0)) : this.grid?.colCount;
		},
		rowCount() {
			return this.rowHeight ? Math.ceil((this.page.unitHeight / this.rowHeight) * (this.grid?.rowCount || 0)) : this.grid?.rowCount;
		},
		cols() {
			//return this.grid?.colCount;
			return this.flyerOrientation === FLYER_ORIENTATION_VERTICAL ? (this.forceColCount || this.colCount): null;
		},
		rows() {
			//return this.grid?.rowCount
			return this.flyerOrientation === FLYER_ORIENTATION_VERTICAL ? null: (this.forceRowCount || this.rowCount);
		},
		unitAspectRatio() {
			return this.page.unitWidth / this.page.unitHeight;
		},
		unitHeight() {
			//return this.rowHeight || (this.colWidth ? (this.colWidth * this.unitAspectRatio) : this.page.unitHeight);
			return this.rowHeight || this.page.unitHeight;
		},
		unitWidth() {
			return this.colWidth || this.page.unitWidth;
		}
	}
}
</script>

<template>
	<grid-renderer :class="layout.type" :rows="rows" :columns="cols" :row-height="unitHeight" :column-width="unitWidth">
		<flyer-block v-for="(b) in blocks"
		             :key="page.id + '_block_' + b.name"
		             :block-data="b"
		             :blockKey="`${page.id}_block_${b.name}`"
		             :page="page"
		             :scale-unit-width="colWidth"
		             :scale-unit-height="rowHeight"
		             :content-fit="layout.contentFit"
		/>
	</grid-renderer>
</template>

<style scoped lang="scss">
	.flyer-block {
	  overflow: hidden;
	}
</style>
<style lang="scss">
.grid-renderer {
  &.simple-tile {
	gap: 20px;
    .flyer-block {
	  border: solid 2px #6d6e71;
    }
  }

  &.simple-grid {
	.flyer-block {
	  border: solid 1px #6d6e71;
	  margin-right: -1px;
	  margin-bottom: -1px;
	}
  }



  .flyer-block {

    > * {
      position: absolute;
    }
	.product-block img, [blockid] img {
	  position: absolute;
	  width: 100% !important;
	  height: 100% !important;
	  left: 0px;
	  top: 0px;
	  object-fit: contain !important;
	  object-position: center center;
	}
  }

}
</style>
